import { Component } from "@angular/core";
import {
  Router,
  ResolveStart,
  ResolveEnd,
  NavigationEnd,
  Scroll,
  Event,
  RouterOutlet,
} from "@angular/router";
import { filter } from "rxjs/operators";
import { ViewportScroller, NgIf } from "@angular/common";
import { MatProgressSpinner } from "@angular/material/progress-spinner";
import { HeaderComponent } from "./header/header.component";
import { SidebarComponent } from "./sidebar/sidebar.component";
import { OffsidebarComponent } from "./offsidebar/offsidebar.component";
import { BreadcrumbComponent } from "../shared/component/breadcrumb/breadcrumb.component";
import { FooterComponent } from "./footer/footer.component";
import { CookiesBannerComponent } from "../shared/component/cookies-banner/cookies-banner.component";

@Component({
  selector: "app-layout",
  templateUrl: "./layout.component.html",
  styleUrls: ["./layout.component.scss"],
  imports: [
    NgIf,
    MatProgressSpinner,
    HeaderComponent,
    SidebarComponent,
    OffsidebarComponent,
    BreadcrumbComponent,
    RouterOutlet,
    FooterComponent,
    CookiesBannerComponent,
  ],
})
export class LayoutComponent {
  public loading = true;
  constructor(
    private router: Router,
    private viewportScroller: ViewportScroller,
  ) {
    this.router.events.subscribe((e: Event) => {
      switch (true) {
        case e instanceof ResolveStart: {
          this.loading = true;
          break;
        }

        case e instanceof ResolveEnd:
        case e instanceof NavigationEnd: {
          this.loading = false;
          break;
        }

        default: {
          break;
        }
      }
    });

    this.router.events.pipe(filter((e) => e instanceof Scroll)).subscribe((e: any) => {
      // this is fix for dynamic generated(loaded..?) content
      setTimeout(() => {
        if (e.position) {
          this.viewportScroller.scrollToPosition(e.position);
        } else if (e.anchor) {
          this.viewportScroller.scrollToAnchor(e.anchor);
        } else {
          this.viewportScroller.scrollToPosition([0, 0]);
        }
      });
    });
  }
}
